import { useEffect } from 'react';
import { usePageDesignerMode } from '@salesforce/storefront-next-runtime/design/react/core';
import { useBlocker } from 'react-router';

/**
 * Imports the Page Designer styles when in design mode.
 */
export function PageDesignerInit() {
    const { isDesignMode } = usePageDesignerMode();

    // Prevent navigation in React Router when in Page Designer design mode
    // so that clicks on links don't cause route changes during editing.
    useBlocker(() => isDesignMode);

    // Dynamically import the Page Designer global styles only when in design mode.
    useEffect(() => {
        if (isDesignMode) {
            void import('@salesforce/storefront-next-runtime/design/styles.css');
        }
    }, [isDesignMode]);

    return <></>;
}
